import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getCurrentPrincipal } from '../../lib/currentPrincipal';
import { principalServiceRequest } from '../../utils/principal-service/base-request';
import { usePrincipals } from './usePrincipals';

export type Scope = {
  name: string;
  description: string;
  active: boolean;
};

export const useScopes = (): UseQueryResult<Scope[], Error> => {
  const { data: principals } = usePrincipals();
  const { currentPrincipal } = getCurrentPrincipal(principals);

  return useQuery({
    queryFn: async () => {
      return await principalServiceRequest<{ scopes: Scope[] }>(
        'get',
        `scopes?principalId=${currentPrincipal.id}`,
      );
    },
    queryKey: ['scopes'],
    select: ({ data }) => data.scopes,
    enabled: true,
    refetchOnWindowFocus: false,
  });
};
